import { Component, OnInit, Inject } from '@angular/core';
import { Student } from '../../../../shared-components/student/student.model';
import { Subscription } from 'rxjs';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProgramAndServiceService } from '../../program-and-service.service';

@Component({
  selector: 'app-invalid-selection-dialog',
  templateUrl: './invalid-selection-dialog.component.html',
  styleUrls: ['./invalid-selection-dialog.component.css']
})
export class InvalidSelectionDialogComponent implements OnInit {

  // Injected Properties
  invalidStudent: Student[] = [];

  // Local Properties
  message = '';
  subscriptions: Subscription[] = [];

  // Class Functions
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogBox: MatDialogRef<any, any>,
    private programAndServiceService: ProgramAndServiceService
  ) { }

  // Event Functions
  ngOnInit() {
    // POST: initializes the data
    if (this.data) {
      if (this.data.invalidStudent) {
        this.invalidStudent = this.data.invalidStudent;
        this.prepareMessage();
      }
    }
  }

  prepareMessage() {
    if (this.invalidStudent.length > 0) {
      this.invalidStudent.forEach(s => {
        this.message += s.LastName + ', ' + s.FirstName + '\n';
      });
      if (this.message.length > 0) {
        this.message = this.message + '\n';
      }
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

  continue(choice: number) {
    // PRE: the Continue button is clicked
    // POST: continue to load landing page and closes the dialog
    this.dialogBox.close(choice);
  }

  back(choice: number) {
    // PRE: the back button is clicked
    // POST: closes the dialog and render the add/edit program and service page
    this.dialogBox.close(choice);
  }
}

